export default __webpack_public_path__ + "static/media/lorenzo-zorzi.4715c46f.svg";